export const overflowEllipsis = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;
